module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: Teach Your Dog to Talk, by Stephanie Rocha",
      "aria-describedby": "cover-alt",
      "role": "doc-cover",
      "src": "e9781646042760/images/9781646042760.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("Teach Your Dog to Talk")]), _vm._v(" "), _c('p', [_vm._v("Get talking in just 15 minutes per day!")]), _vm._v(" "), _c('p', [_vm._v("A Beginner’s Guide to Training Your Dog to Communicate with Word Buttons")]), _vm._v(" "), _c('p', [_vm._v("Stephanie Rocha")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38883560","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042760/xhtml/cover.vue
// module id = 54
// module chunks = 0